(
    function (skyward, $)
    {
        var datesToUseRadioGroupID = "DatesToUse";
        var datesToUseContainer;
        var startDateContainer;
        var endDateContainer;
        var studentSectionDetailsSectionHeader;

        var init = function (selector)
        {
            if ($(selector).find("#SchedulingGroupInput").length > 0)
            {
                $(selector).find("#SchedulingGroupID").on("eelComplete", hideOrShowDatesToUseBasedOnCodeel);

                datesToUseContainer = $("#DatesToUseContainer");
                startDateContainer = $("#StartDateContainer");
                endDateContainer = $("#EndDateContainer");
                studentSectionDetailsSectionHeader = $("#StudentSectionDetailsHdr");
                hideOrShowDatesToUseBasedOnCodeel();
            }
        };

        var hideOrShowDatesToUseBasedOnCodeel = function ()
        {
            var typeCode;
            if ($("#SchedulingGroupID").data("additionalFields") != undefined)
            {
                typeCode = $("#SchedulingGroupID").data("additionalFields").TypeCode;
            }
            if (typeCode === undefined)
            {
                typeCode = $("#SchedulingGroupTypeCode").val();
            }
            else if (typeCode != $("#SchedulingGroupTypeCode").val())
            {
                $("#SchedulingGroupTypeCode").val(typeCode);
            }

            if (typeCode === undefined)
            {
                hideDates();
            }
            else if (typeCode === "S")
            {
                showDates();
            }
            else
            {
                hideDates();
            }
        };

        var hideDates = function ()
        {
            skyward.controls.hide(startDateContainer);
            skyward.controls.hide(endDateContainer);
            skyward.controls.hide(datesToUseContainer);
            skyward.controls.hide(studentSectionDetailsSectionHeader);
        };

        var showDates = function ()
        {
            skyward.controls.show(studentSectionDetailsSectionHeader);

            var radioBoxSelected = "";
            $("#" + datesToUseRadioGroupID).find("input").each(function (index, element)
            {
                if (skyward.controls.getValue($(element)) != undefined)
                {
                    radioBoxSelected = skyward.controls.getValue($(element));
                }
            });

            if (radioBoxSelected == "EnterDatesToUse")
            {
                skyward.controls.show(startDateContainer);
                skyward.controls.show(endDateContainer);
            }
            skyward.controls.show(datesToUseContainer);
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);